import DetailBDSGeneralInformation from "./DetailBDSGeneralInformation";
import React from 'react';
import PropTypes from 'prop-types';
import { VALUE_CLS, CHECK_DISPLAY_CLS } from "../pifStyles";
import { useDiffMark, useDiffTitle } from "./PifDiffContext";
import DiffRichText from "./DiffRichText";

const DetailBDS3 = ({project, building, adaptation, area, areaIndex}) => {
  const {bds3} = area;
  const mark = useDiffMark();
  const p = (k) => `areas[${areaIndex}].bds3.${k}`;
  // old → new tooltip for a highlighted field (inert when not changed).
  const title = useDiffTitle();
  const vtitle = (k) => title(p(k));

  return (
    <div className="tw-text-sm tw-border tw-border-solid tw-border-slate-200 tw-p-3 tw-bg-white tw-rounded">
      <DetailBDSGeneralInformation
        project={project}
        building={building}
        adaptation={adaptation}
        area={area}
      />
      <h6 className="tw-text-center tw-my-2">This area only : Page 3 of 3</h6>

      <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mt-5 tw-mb-3">
        <div className="tw-col-span-5 tw-font-semibold">1. Please design the most economical purlin, girt spacing.</div>
        <div className="tw-col-span-7">
          <span className={`${VALUE_CLS}${mark(p('purlin_girt_spacing'))}`} title={vtitle('purlin_girt_spacing')}>{bds3.purlin_girt_spacing}</span>
        </div>
      </div>

      <div className="tw-mb-3">
        <div className="tw-grid tw-grid-cols-12 tw-gap-x-2">
          <div className="tw-col-span-5 tw-font-semibold">2. Deflection criterion:</div>
          <div className="tw-col-span-7">
            <div className="tw-flex tw-justify-between">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  className={CHECK_DISPLAY_CLS}
                  checked={!!bds3.follow_building_code}
                  readOnly
                />
                <span className={mark(p('follow_building_code'))} title={vtitle('follow_building_code')}>Follow building code</span>
              </label>

              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  className={CHECK_DISPLAY_CLS}
                  checked={!!bds3.follow_peb_standard}
                  readOnly
                />
                <span className={mark(p('follow_peb_standard'))} title={vtitle('follow_peb_standard')}>Follow peb standard</span>
              </label>

              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  className={CHECK_DISPLAY_CLS}
                  checked={!!bds3.follow_requested_of_client}
                  readOnly
                />
                <span className={mark(p('follow_requested_of_client'))} title={vtitle('follow_requested_of_client')}>Follow requested of client</span>
              </label>
            </div>
          </div>
        </div>
        <div className="tw-grid tw-grid-cols-12 tw-gap-x-2">
          <div className="tw-col-span-5">Requested of Client:</div>
          <div className="tw-col-span-7">
            <DiffRichText path={p('follow_requested_of_client_specify')} html={bds3.follow_requested_of_client_specify} className={VALUE_CLS} />
          </div>
        </div>
      </div>

      <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-3">
        <div className="tw-col-span-4 tw-font-semibold">3. Environment conditions:</div>
        <div className="tw-col-span-8">
          <div className="tw-flex tw-justify-between">
            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.fertilizer}
                readOnly
              />
              <span className={mark(p('fertilizer'))} title={vtitle('fertilizer')}>Fertilizer</span>
            </label>

            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.chemical_substance}
                readOnly
              />
              <span className={mark(p('chemical_substance'))} title={vtitle('chemical_substance')}>Chemical substance</span>
            </label>

            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.animal_feed}
                readOnly
              />
              <span className={mark(p('animal_feed'))} title={vtitle('animal_feed')}>Animal feed</span>
            </label>

            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.animal_shed}
                readOnly
              />
              <span className={mark(p('animal_shed'))} title={vtitle('animal_shed')}>Animal shed</span>
            </label>

            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.from_the_sea_100m}
                readOnly
              />
              <span className={mark(p('from_the_sea_100m'))} title={vtitle('from_the_sea_100m')}>From the sea 100m</span>
            </label>
          </div>
        </div>
      </div>

      <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-3">
        <div className="tw-col-span-5 tw-font-semibold">4. How many cranes can operate at the same time in the same bay?</div>
        <div className="tw-col-span-7">
          <div className="tw-flex tw-justify-between">
            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.crane_operate_2}
                readOnly
              />
              <span className={mark(p('crane_operate_2'))} title={vtitle('crane_operate_2')}>2</span>
            </label>

            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.crane_operate_3}
                readOnly
              />
              <span className={mark(p('crane_operate_3'))} title={vtitle('crane_operate_3')}>3</span>
            </label>

            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.crane_operate_4}
                readOnly
              />
              <span className={mark(p('crane_operate_4'))} title={vtitle('crane_operate_4')}>4</span>
            </label>

            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.crane_operate_not_apply}
                readOnly
              />
              <span className={mark(p('crane_operate_not_apply'))} title={vtitle('crane_operate_not_apply')}>Not Apply</span>
            </label>
          </div>
        </div>
      </div>

      <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-3">
        <div className="tw-col-span-5 tw-font-semibold">5. Is Internal X-Bracing allowed?</div>
        <div className="tw-col-span-7">
          <div className="tw-flex tw-justify-between">
            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.internal_xbracing_yes}
                readOnly
              />
              <span className={mark(p('internal_xbracing_yes'))} title={vtitle('internal_xbracing_yes')}>Yes</span>
            </label>

            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.internal_xbracing_no}
                readOnly
              />
              <span className={mark(p('internal_xbracing_no'))} title={vtitle('internal_xbracing_no')}>No</span>
            </label>

            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                checked={!!bds3.internal_xbracing_not_apply}
                readOnly
              />
              <span className={mark(p('internal_xbracing_not_apply'))} title={vtitle('internal_xbracing_not_apply')}>Not Apply</span>
            </label>
          </div>
        </div>
      </div>

      <div className="tw-mb-3">
        <div>
          <div className="tw-font-semibold">6. The Top Coat Paint shall be Flat or Matte Finish ( Very low on Reflectivity)</div>
          <div className="tw-mt-3">
            <DiffRichText path={p('top_coat_paint')} html={bds3.top_coat_paint} />
          </div>
        </div>
      </div>
    </div>
  )
};

DetailBDS3.propTypes = {
  project: PropTypes.object.isRequired,
  building: PropTypes.object.isRequired,
  adaptation: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  areaIndex: PropTypes.number
}

export default DetailBDS3;
